module.exports = __webpack_public_path__ + "static/media/dhara.d2fb00fd.ogg";